import React from 'react';
import classnames from 'classnames';

import SafeAnchor from '@hydra/common/components/SafeAnchor';
import { makeStyles } from '@material-ui/core/styles';

import { isLightColor } from '@hydra/utils/colors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    whiteSpace: 'nowrap',
    margin: theme.spacing(0.5, 0.25)
  },
  text: {
    padding: theme.spacing(0.375, 0.625),
    background: theme.palette.secondary.lighter,
    borderRadius: '3px 0 0 3px',
    maxWidth: '650px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  amount: {
    padding: theme.spacing(0.375, 0.625),
    borderRadius: '0 3px 3px 0'
  },
  light: {
    color: theme.palette.common.white
  },
  dark: {
    color: theme.palette.common.black
  }
}));

interface CriteriumKeywordsCloudTagProps {
  keyword: string
  url?: string
  className?: string
  amount: number
  color: string
}

export const CriteriumKeywordsCloudTag = ({ keyword, url, amount, color, className }: CriteriumKeywordsCloudTagProps) => {
  const classes = useStyles();
  const isLight = isLightColor(color);
  return (
    <span className={classnames(classes.root, className)}>
      <span className={classes.text}>
        {
          url
            ? <SafeAnchor href={url} rel='nofollow noopener noreferrer' target='_blank'>{keyword}</SafeAnchor>
            : keyword
        }
      </span>
      {
        amount !== null && amount !== undefined
          ? (
            <span
              style={{ background: color }}
              className={classnames(classes.amount, isLight ? classes.dark : classes.light)}
            >
              {amount}
            </span>
            )
          : null
      }
    </span>
  );
};

export default CriteriumKeywordsCloudTag;
